var lib_core = require("lib-core");
var ContentServerMetaData = require("../contentServerMetaData.js");

var LibraryMetaData = function () {
    ContentServerMetaData.call(this);
};

lib_core.inherit(LibraryMetaData, ContentServerMetaData);
lib_core.JsonParser.registerClass(LibraryMetaData, "LibraryMetaData");
module.exports = LibraryMetaData;

LibraryMetaData.prototype.assetType = function () {
	return "library";
};

LibraryMetaData.prototype.assetPath = function () {
	return "libraries/";
};
